<template>
    <div class="event-related-feed">
        <el-row :gutter="0">
            <el-col :span="6">
                <div class="total-feed">
                    <div class="value">{{ relatedFeeds.length }} feed{{relatedFeeds.length > 1 ? 's' : ''}}</div>
                </div>
            </el-col>
        </el-row>

        <gcmcn-filters
            :filter-values="[selectedSortType, searchFilter, selectedfeedStatus, dateRange, selectedEntitiesForFilter]"
            @reset-filters="resetFilters"
        >
            <dropdown
                name="Sort"
                :multiple="false"
                :list="$store.getters.sortTypeList"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                @on-select-item="selectedSortType = $event"
            ></dropdown>
            <dropdown
                name="Status"
                :list="$store.getters.availableFeedStatus"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedfeedStatus"
                @on-select-item="selectedfeedStatus = $event"
            ></dropdown>
            <dropdown
                name="Entities"
                :multiple="true"
                :list="$store.getters.entities"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedEntitiesForFilter"
                @on-select-item="onSelectEntity"
            ></dropdown>
            <date-picker-range ref="date-range" @on-range-selected="setDaterange"></date-picker-range>
            <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
        </gcmcn-filters>
        <virtual-list
            v-if="filteredFeeds.length > 0"
            class="feed-virtual-list"
            :style="{height: `calc(100vh - ${this.feedListHeight}px)`}"
            :data-key="'uid'"
            :data-sources="filteredFeeds"
            :data-component="itemComponent"
            :keeps="10"
            :extimate-size="111"
            item-class="feed-item"
            :extra-props="{
                otherPropValue: {
                    universes: universes,
                    events: events,
                    configurations: [],
                    displayConfigButton: false,
                    defaultPreviewImageUrl: defaultPreviewImageUrl,
                    unMutedFeedsUid: unMutedFeedsUid
                }
            }"
        ></virtual-list>
        <div v-else class="list-empty">No feed</div>
    </div>
</template>

<script>
import relatedFeed from './relatedFeed.vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import VirtualList from 'vue-virtual-scroll-list';

import {
    GcmcnFilters,
    Dropdown,
    SearchFilter,
    DatePickerRange,
} from 'gcmcn-common';

export default {

    components: {
        GcmcnFilters,
        DatePickerRange,
        Dropdown,
        SearchFilter,
    },
    name: 'feeds-view',
    props: {
        relatedFeeds: {
            type: Array,
            required: true
        },
        event: {
            type: Object,
            required: true
        },
        universes: {
            type: Array,
            required: true
        },
        events: {
            type: Array,
            required: true
        }
    },

    data: function(){
        return {
            retrievedFeeds: [],
            loading: true,
            selectedSortType: '',
            searchFilter: '',
            selectedfeedStatus: [],
            dateRange: '',
            unMutedFeedsUid: [],
            itemComponent: relatedFeed
        };
    },
    created() {
        this.$on('toggleSound', (payload) => {
            if (payload.muted === false) {
                if (!this.unMutedFeedsUid.includes(payload.feedUid)) {
                    this.unMutedFeedsUid.push(payload.feedUid);
                }
            } else {
                if (this.unMutedFeedsUid.includes(payload.feedUid)) {
                    this.unMutedFeedsUid.splice(this.unMutedFeedsUid.indexOf(payload.feedUid), 1);
                }
            }
        });
    },
    computed: {
        ...mapGetters([
            'takersByUid',
            'selectedEntitiesForFilter',
        ]),
        feedListHeight (){
            return this.$store.getters.pageHeight + 83; // 83 -> filters height
        },
        defaultPreviewImageUrl() {
            return '../../../../static/image/no_preview.png';
        },
        filteredFeeds (){
            let feeds = this.relatedFeeds.slice();
            if(this.selectedfeedStatus.length > 0){
                feeds = feeds.filter((feed) => this.selectedfeedStatus.includes(feed.status));
            }
            if(this.selectedEntitiesForFilter.length > 0){
                feeds = feeds.filter((feed) => this.selectedEntitiesForFilter.includes(feed.scopes.entity_uid));
            }

            if(this.dateRange.length > 0){
                // obbligé d'ajouter 1 jours car si le user selectionne par exemple le 30/07/2020 la valeur retournée sera 29/07/2020
                let start = moment.utc(this.dateRange[0]).set({hour: 0, minute: 0, second: 0}).add(1, 'days');
                let end = moment.utc(this.dateRange[1]).set({hour: 23, minute: 59, second: 59}).add(1, 'days');
                feeds = feeds.filter((feed) => {
                    const feedStartDate = feed.confirmed ? feed.confirmed_start_date : feed.start_date;
                    const feedEndDate = feed.confirmed ? feed.confirmed_end_date : feed.end_date;
                    return moment.utc(feedStartDate).isAfter(start) && moment.utc(feedEndDate).isBefore(end);
                });
            }
            if(this.selectedSortType.length > 0){
                feeds.sort((a,b) => {
                    return new Date(b.confirmed ? b.confirmed_start_date : b.start_date) - new Date(a.confirmed ? a.confirmed_start_date : a.start_date);
                });
                if(this.selectedSortType === 'asc'){
                    feeds.reverse();
                }
            }
            if(this.searchFilter.length > 0){
                let searchFilter = this.searchFilter.toLowerCase();
                feeds = feeds.filter((feed) => feed.display_name.toLowerCase().includes(searchFilter) ||
                    this.event.name.toLowerCase().includes(searchFilter)
                );
            }
            return this.$store.getters.orderingFeeds(feeds);
        },
    },

    mounted: function(){
    },

    methods: {
        setDaterange (val){
            this.$set(this, 'dateRange', val);
        },
        resetFilters (){
            this.$set(this, 'selectedfeedStatus', []);
            this.selectedSortType = '';
            this.$refs.search.clear();
            this.$refs['date-range'].clear();
            this.$store.commit('CLEAR_ALL_FILTERS');
        },
        onSelectEntity (entities){
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
        },
    },
};
</script>

<style lang="scss">
.event-related-feed {
    color: #bbb;
    margin-top: 10px;
    padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Events/eventRelatedFeedsList.vue